import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  ref: "rootEl",
  class: "col-12 col-md-5 m-auto d-flex align-items-center justify-content-between"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "bi bi-play-fill"
}
const _hoisted_5 = {
  key: 1,
  class: "bi bi-pause-fill"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "col-12 mt-2 px-3 text-center small text-white-50 text-truncate"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BRange = _resolveComponent("BRange")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "btn btn-secondary bg-secondary bg-opacity-05 border-0",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fastForward(-10 * 60)))
      }, [
        _createElementVNode("img", {
          src: _ctx.$getImage('icons8-replay-10-48.png', 'icons'),
          class: "col-10",
          alt: ""
        }, null, 8, _hoisted_2)
      ]),
      _createElementVNode("button", {
        class: "btn btn-secondary bg-secondary bg-opacity-05 border-0",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fastForward(-5)))
      }, [
        _createElementVNode("img", {
          src: _ctx.$getImage('icons8-replay-5-48.png', 'icons'),
          class: "col-10",
          alt: ""
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("button", {
        class: "btn btn-secondary bg-secondary bg-opacity-05 border-0 fs-1",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.togglePlay && _ctx.togglePlay(...args))),
        style: {"width":"72px","height":"72px"}
      }, [
        (!_ctx.play)
          ? (_openBlock(), _createElementBlock("i", _hoisted_4))
          : (_openBlock(), _createElementBlock("i", _hoisted_5))
      ]),
      _createElementVNode("button", {
        class: "btn btn-secondary bg-secondary bg-opacity-05 border-0",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.fastForward(5)))
      }, [
        _createElementVNode("img", {
          src: _ctx.$getImage('icons8-forward-5-48.png', 'icons'),
          class: "col-10",
          alt: ""
        }, null, 8, _hoisted_6)
      ]),
      _createElementVNode("button", {
        class: "btn btn-secondary bg-secondary bg-opacity-05 border-0",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.fastForward(10 * 60)))
      }, [
        _createElementVNode("img", {
          src: _ctx.$getImage('icons8-forward-10-48.png', 'icons'),
          class: "col-10",
          alt: ""
        }, null, 8, _hoisted_7)
      ])
    ], 512),
    (_ctx.playbackLabel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.playbackLabel), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_BRange, {
      modelValue: _ctx.rangeValue,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.rangeValue) = $event)),
      onDragStart: _ctx.onDragStart,
      onRangeCommit: _ctx.onRangeCommit,
      onDragEnd: _ctx.onDragEnd,
      class: "mt-3"
    }, null, 8, ["modelValue", "onDragStart", "onRangeCommit", "onDragEnd"])
  ], 64))
}